import React, {ChangeEventHandler, ReactElement} from "react";
import {EditBrandMapBodyFrontend} from "./BrandMapFormValues";

interface Props {
	formValues: EditBrandMapBodyFrontend;
	inputOnChange: (key: keyof EditBrandMapBodyFrontend) => ChangeEventHandler<HTMLInputElement>;
}

function EditBrandMapMainPromoTagline(props: Props): ReactElement {

	return (
		<div className="create-map-page_container create-map-page_main-promo">
			<div className="create-map-page_container_inner create-map-page_main-promo_tagline">
				<h5>
					Main Promotion Tagline
				</h5>
				<p>
					Write a tagline that appears under the main promotion title. This will only appear if there is a main promotion set.
				</p>
				<input
					placeholder="Eg. Get 10% when you place an order over $15!"
					value={props.formValues.promoTagline}
					onChange={props.inputOnChange("promoTagline")}
				/>
			</div>
		</div>
	);
}

export default EditBrandMapMainPromoTagline;
